import { render, staticRenderFns } from "./MonitorarTeorica.vue?vue&type=template&id=713f6062&scoped=true"
import script from "./MonitorarTeorica.vue?vue&type=script&lang=js"
export * from "./MonitorarTeorica.vue?vue&type=script&lang=js"
import style0 from "./MonitorarTeorica.vue?vue&type=style&index=0&id=713f6062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f6062",
  null
  
)

export default component.exports